import { DcBaseComponent } from '@deleteagency/dc';
import throttle from 'lodash.throttle';

export default class InfiniteScroll extends DcBaseComponent {
    constructor(...args) {
        super(...args);

        this.isLoading = false;
        this.nextUrl = this.element.dataset.nextUrl;
    }

    static getNamespace() {
        return 'infinite-scroll';
    }

    static getRequiredRefs() {
        return ['list', 'spinner'];
    }

    onInit() {
        if (this.nextUrl) {
            this._check();

            this.observer = new MutationObserver(this._updateNextUrl);
            this.observer.observe(this.element, { attributes: true });

            this.addListener(window, 'scroll', throttle(this._check, 100));
        }
    }

    _getContent() {
        if (!this.nextUrl) return;

        jQuery(() => {
            $.ajax({
                type: 'GET',
                url: this.nextUrl,
                beforeSend: () => {
                    this.isLoading = true;
                    this._showHideSpinner();
                },
                success: (response) => this._onSuccess(response)
            });
        });
    };

    _onSuccess({ data }) {
        this.isLoading = false;

        this._showHideSpinner();

        if (data.content) {
            this._appendContent(data.content);
        }

        data.nextUrl ? this.nextUrl = data.nextUrl : this.nextUrl = null;
    };

    _appendContent(content) {
        const fragment = document.createDocumentFragment();
        const nodes = jQuery.parseHTML(content);

        nodes.forEach((node) => fragment.appendChild(node));

        this.refs.list.appendChild(fragment);
    };

    _showHideSpinner() {
        this.isLoading
            ? this.refs.spinner.classList.remove('d-none')
            : this.refs.spinner.classList.add('d-none');
    };

    _check = () => {
        if (this.isLoading) return;

        const bottom = this.element.getBoundingClientRect().bottom;

        if (window.innerHeight - bottom >= -150) {
            this._getContent();
        }
    };

    _updateNextUrl = () => {
        this.nextUrl = this.element.dataset.nextUrl;
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
}
